import React from 'react'

function Form() {
    return (
        <section id="contact" className="bg-cover bg-center bg-no-repeat h-full w-full relative" >
            <div className="container px-5 py-24 mx-auto">
                <div className="flex flex-col text-center w-full mb-12">
                    <p className="mx-auto text-3xl font-bold text-blue-500">CONTACT US</p>
                    <h1 className="sm:text-1xl text-2xl	text-white font-normal mb-4">Get in touch with us for your upcoming projects</h1>
                </div>
                <div className="lg:w-1/2 md:w-2/3 mx-auto bg-white rounded-xl">
                    <div className="flex flex-wrap p-7">
                        <form target="_blank" action="https://formsubmit.co/bitpro6688@gmail.com" method="POST" className="w-full text-center item-center">
                            <div className="py-2 w-full">
                                <input type="text" placeholder="Full Name" name="name" required className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 text-base outline-none text-gray-700 py-1 px-3 leading-8" />
                            </div>
                            <div className="py-2 w-full">
                                <input type="text" placeholder="Email Address" name="email" required className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 text-base outline-none text-gray-700 py-1 px-3 leading-8" />
                            </div>
                            <div className="py-2 w-full">
                                <textarea placeholder="Your Message" name="message" rows="10" required className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 text-base outline-none text-gray-700 py-1 px-3 leading-8"></textarea>
                            </div>
                            <button className='rounded px-20 py-3 text-white bg-blue-500 hover:bg-blue-600'>Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </section >
    )
}


export default Form